import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router';
import { PATH_ROOT } from '@/constants/constant';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';

interface PublicRouteProps {
  restricted?: boolean;
}

const PublicRoute: React.FC<PublicRouteProps & RouteProps> = (routeProps: PublicRouteProps & RouteProps) => {
  const account = useSelector((state: RootState) => state.account);

  if (account.user && routeProps?.restricted) {
    return <Redirect to={account.prevPage || PATH_ROOT} />;
  }
  return <Route {...routeProps} />;
};

export default PublicRoute;
